import { Pipe, PipeTransform } from '@angular/core';
import { BlahService } from '@headpower/blah-ng';

@Pipe({
  name: 'titleName'
})
export class TitleNamePipe implements PipeTransform {
  private translationPath: string = 'newTaskList.';

  constructor(private blahService: BlahService) { }

  transform(value: string, group: string): string {

    if (!value || value.trim() === '' || !group || group.trim() === '') return '';

    const path = `${this.translationPath}${group}`;

    // Check if need prefix
    if (value.includes('_')) {
      const keys = value.split('_')

      const prefix = value.includes('.')
        ? this.blahService.blah(`${keys[0]}`)
        : this.blahService.blah(`${path}.${keys[0]}`);

      const translatedValue = this.blahService.blah(`${path}.${keys[1]}`).toLocaleLowerCase();

      // Return translated value with prefix
      return `${prefix} ${translatedValue}`;
    }

    // Check if has path to JSON file
    if (value.includes('.')) {
      return this.blahService.blah(value);
    }

    // Return translated value using default path 
    return this.blahService.blah(`${path}.${value}`)
  }
}
